import React, { useContext, useState, useEffect, useRef } from "react";
import PropTypes from "prop-types";
import {
  Divider,
  Grid,
  Typography,
  Checkbox,
  FormControlLabel,
  Stack,
  TextField,
  Tooltip,
  Fade,
  Menu,
  MenuItem,
  ListItemIcon,
} from "@mui/material";
import { Public, TripOrigin } from "@mui/icons-material";
import withStyles from "@mui/styles/withStyles";
import {
  numberFormat,
  formatDate,
  formatSmallDate,
} from "../../extends/NumberFormat";
import { WideColorButton } from "../ColorButtons/ColorButtons";
import { KeyboardArrowDown } from "@mui/icons-material";
import PopoverEventDetails from "../PopoverEventDetails/PopoverEventDetails";
import { useSnackbar } from "notistack";
import { NumericFormat } from "react-number-format";
import { UserContext } from "../../UserContext";
import PaymentMethod from "./PaymentMethod";
import PaymentGratuity from "./PaymentGratuity";
const styles = (theme) => ({
  colorUnderline: {
    borderBottom: `1px solid #0091ff`,
    "&:before": {
      borderBottom: `1px solid #0091ff`,
    },
    "&:after": {
      borderBottom: `1px solid #0091ff`,
    },
  },
  margin: {
    marginTop: 10,
  },
  smallFont: {
    fontSize: 14,
  },
  red: {
    color: "red",
  },
  bold: {
    fontWeight: "bold",
  },
  center: {
    textAlign: "center",
    marginTop: 20,
  },
  border: {
    border: "1px solid #F6F6F9",
    borderRadius: 10,
    background: "#F6F6F9",
    padding: 13,
    marginBottom: 20,
  },
  active: {
    color: "white",
    backgroundColor: "#0091FF !important",
  },
  icon: {
    transition: "0.5s all",
  },
  iconActive: {
    transition: "0.5s all",
    transform: "rotate(180deg)",
  },
  flex: {
    display: "flex",
    justifyContent: "flex-end",
  },
  flexStart: {
    display: "flex",
    justifyContent: "flex-start",
  },
  flexCenter: {
    display: "flex",
    cursor: "pointer",
    justifyContent: "center",
    alignItems: "center",
    marginTop: 10,
  },
  paymentInfoLeft: {
    width: "300px",
    textAlign: "right",
    fontWeight: "bold",
    paddingRight: 10,
  },
  gratuityButtons: {
    border: "1px solid black",
    borderRadius: "5px",
    textAlign: "center",
    fontWeight: "bold",
    padding: "2px 4px",
  },
  gratuityButtonSelected: {
    border: "1px solid black",
    borderRadius: "5px",
    backgroundColor: "#337ab7",
    color: "#fff",
    textAlign: "center",
    fontWeight: "bold",
    padding: "2px 4px",
  },
  ifmPaymentConfirmation: {
    height: 0,
    width: 0,
    position: "absolute",
  },
});

const GreenCheckbox = withStyles({
  root: {
    "&$checked": {
      color: "green",
    },
  },
  checked: {},
})((props) => <Checkbox color="default" {...props} />);

const PaymentEntryField = withStyles({
  root: {
    borderBottom: `1px solid #0091ff`,
    "& .MuiInput-underline:after": {
      borderBottom: `1px solid #0091ff`,
    },
  },
})((props) => <TextField {...props} variant="standard" />);

const PaymentsSchedule = (props) => {
  const {
    sendCommentCallback,
    classes,
    payments,
    token,
    eventId,
    applyTPPPayFee,
    applyACHPayFee,
    tppPayFeePercentage,
    tppPayFeeLabel,
    showACH,
    applyTPPPayGratuity,
    tppPayGratuityLabel,
    defaultGratuity1,
    defaultGratuity2,
    defaultGratuity3,
    selectedDefaultGratuity,
    processPaymentCallback,
    country = "en-US",
  } = props;
  let [selectedinvoiceAmount, setSelectedInvoiceAmount] = useState(0);
  let [tppPayFeeAmount, setTPPPayFeeAmount] = useState(0);
  let [tppPayGratuityAmount, setTPPPayGratuityAmount] = useState(0);
  let [selectedinvoiceTotalAmount, setSelectedInvoiceTotalAmount] = useState(0);
  let [paymentGratuityOption, setPaymentGratuityOption] = useState(-1);
  const selectedGratuity = useRef(-1);
  let [paymentTypeOption, setPaymentTypeOption] = useState(0);
  let [customSelected, setCustomSelected] = useState(0);
  let selectedPaymentTypeOption =
    paymentTypeOption !== "0" ? paymentTypeOption : null;
  let selectedGratuityPercent = 0;
  let customGratuityAmount = customSelected !== 0 ? customSelected : 0;
  const [paymentArray, setPaymentArray] = useState(payments);
  const [payNowMenuAnchor, setPayNowMenuAchnor] = useState(null);

  const isCanadian = country === "CA";

  const {
    settings: { acceptPayments, allowPartialPayments, showScheduledPayments },
  } = useContext(UserContext);

  const { enqueueSnackbar } = useSnackbar();

  if (paymentGratuityOption === -1 && applyTPPPayGratuity) {
    if (selectedDefaultGratuity === 1) {
      selectedGratuityPercent = defaultGratuity1;
    } else if (selectedDefaultGratuity === 2) {
      selectedGratuityPercent = defaultGratuity2;
    } else if (selectedDefaultGratuity === 3) {
      selectedGratuityPercent = defaultGratuity3;
    }
    setPaymentGratuityOption(parseFloat(selectedGratuityPercent));
  } else {
    selectedGratuityPercent = paymentGratuityOption;
  }

  const [comment, setComment] = useState("");
  const handleChange = (index) => {
    paymentArray[index].showMore = !paymentArray[index].showMore;
    setPaymentArray([...paymentArray]);
  };

  useEffect(() => {
    calculateTotal();
  }, []);

  const calculateTotal = () => {
    let otherAmountWithFee = paymentArray
      .filter((el) => el.otherAmountChecked && el.event.applyTPPpayFee)
      .reduce((a, b) => (b.otherAmount ? a + b.otherAmount : a), 0);
    let otherAmount = paymentArray
      .filter((el) => el.otherAmountChecked && !el.event.applyTPPpayFee)
      .reduce((a, b) => (b.otherAmount ? a + b.otherAmount : a), 0);
    let paymentAmountWithFee = paymentArray
      .filter((el) => el.event.applyTPPpayFee)
      .map((el) => el.scheduledPayments)
      .flat()
      .filter((item) => item.checked)
      .reduce((a, b) => (b.paymentAmount ? a + b.paymentAmount : a), 0);
    let paymentAmount = paymentArray
      .filter((el) => !el.event.applyTPPpayFee)
      .map((el) => el.scheduledPayments)
      .flat()
      .filter((item) => item.checked)
      .reduce((a, b) => (b.paymentAmount ? a + b.paymentAmount : a), 0);
    let calculateFee =
      paymentArray.filter((el) => el.event.applyTPPpayFee).length > 0;
    let calculateGratuity =
      paymentArray.filter((el) => el.event.applyTPPpayGratuity).length > 0;

    if (otherAmountWithFee + paymentAmountWithFee > 0) {
      otherAmountWithFee = otherAmountWithFee + otherAmount;
      otherAmount = 0;
      paymentAmountWithFee = paymentAmountWithFee + paymentAmount;
      paymentAmount = 0;
    }
    setSelectedInvoiceAmount(
      otherAmountWithFee + otherAmount + paymentAmountWithFee + paymentAmount
    );
    let gratuityAmount = parseFloat(
      (
        ((otherAmountWithFee +
          otherAmount +
          paymentAmountWithFee +
          paymentAmount) *
          selectedGratuityPercent) /
        100
      ).toFixed(2)
    );
    if (
      selectedGratuityPercent === 0 &&
      (customGratuityAmount || tppPayGratuityAmount)
    ) {
      gratuityAmount = customGratuityAmount;
    }
    if (!calculateGratuity) {
      gratuityAmount = 0;
    }
    let convenienceAmount = parseFloat(
      (
        ((otherAmountWithFee +
          otherAmount +
          paymentAmountWithFee +
          paymentAmount +
          gratuityAmount) *
          tppPayFeePercentage) /
        100
      ).toFixed(2)
    );
    if (
      (selectedPaymentTypeOption === "1" && !applyACHPayFee) ||
      !applyTPPPayFee ||
      !calculateFee
    ) {
      convenienceAmount = 0;
    }
    setTPPPayFeeAmount(convenienceAmount);
    setTPPPayGratuityAmount(gratuityAmount);
    setSelectedInvoiceTotalAmount(
      convenienceAmount +
        gratuityAmount +
        (otherAmountWithFee +
          otherAmount +
          paymentAmountWithFee +
          paymentAmount)
    );
  };

  const handleAmount = (index, value) => {
    paymentArray[index].otherAmount = value;
    paymentArray[index].otherAmount
      ? (paymentArray[index].otherAmountChecked = true)
      : (paymentArray[index].otherAmountChecked = false);
    paymentArray[index].scheduledPayments.map((el) =>
      el.paymentType.id === "B" ? (el.checked = false) : el
    );
    calculateTotal();
  };

  const handleGratuityAmount = (value) => {
    setTPPPayGratuityAmount(value);
    customGratuityAmount = isNaN(value) ? 0 : value;
    setCustomSelected(customGratuityAmount);
    calculateTotal();
  };

  const handleChangePayment = (indexArr, indexPayment) => {
    let calculateFee =
      paymentArray.filter((el) => el.event.applyTPPpayFee).length > 0;
    let calculateGratuity =
      paymentArray.filter((el) => el.event.applyTPPpayGratuity).length > 0;

    paymentArray[indexArr].scheduledPayments[indexPayment].checked =
      !paymentArray[indexArr].scheduledPayments[indexPayment].checked;

    if (
      paymentArray[indexArr].scheduledPayments[indexPayment].paymentType.id !==
      "B"
    ) {
      if (
        paymentArray[indexArr].scheduledPayments.find(
          (element) =>
            element.paymentType.id === "B" && element.checked === true
        )
      )
        paymentArray[indexArr].scheduledPayments.map((element) =>
          element.paymentType.id === "B" ? (element.checked = false) : element
        );
    }

    if (
      paymentArray[indexArr].scheduledPayments[indexPayment].paymentType.id ===
      "B"
    ) {
      paymentArray[indexArr].scheduledPayments.map((element) => {
        if (element.paymentType.id !== "B") element.checked = false;

        paymentArray[indexArr].otherAmountChecked = false;
        return element;
      });
    }

    let invoiceInfo =
      paymentArray[indexArr].scheduledPayments[indexPayment].invoiceInfo;
    if (
      paymentArray[indexArr].scheduledPayments[indexPayment].checked &&
      calculateGratuity
    ) {
      invoiceInfo.tppPayGratuityPercentage = selectedGratuityPercent;
      invoiceInfo.tppPayGratuityAmount = parseFloat(
        ((invoiceInfo.amount * selectedGratuityPercent) / 100).toFixed(2)
      );
    } else {
      invoiceInfo.tppPayGratuityPercentage = 0;
      invoiceInfo.tppPayGratuityAmount = 0;
    }

    if (
      paymentArray[indexArr].scheduledPayments[indexPayment].checked &&
      calculateFee &&
      (paymentTypeOption !== "1" ||
        (paymentTypeOption === "1" && applyACHPayFee))
    ) {
      invoiceInfo.tppPayFeePercentage = tppPayFeePercentage;
      invoiceInfo.tppPayFeeAmount = parseFloat(
        (
          ((invoiceInfo.amount + invoiceInfo.tppPayGratuityAmount) *
            tppPayFeePercentage) /
          100
        ).toFixed(2)
      );
    } else {
      invoiceInfo.tppPayFeePercentage = 0;
      invoiceInfo.tppPayFeeAmount = 0;
    }

    setPaymentArray([...paymentArray]);
    calculateTotal();
  };

  const otherAmountCheck = (element) => {
    var match = element.scheduledPayments.find(
      (element) => element.paymentType.id === "B" && element.checked === true
    );
    if (match) {
      element.scheduledPayments.map((element) =>
        element.paymentType.id === "B" ? (element.checked = false) : element
      );
    }
    element.otherAmountChecked = !element.otherAmountChecked;
    setPaymentArray([...paymentArray]);
    calculateTotal();
  };

  const sendComment = () => {
    if (comment.length > 0) {
      let otherAmount = paymentArray
        .filter((el) => el.otherAmountChecked)
        .map((element) => element.event.id);
      let paymentAmount = payments
        .map((el) => el.scheduledPayments)
        .flat()
        .filter((item) => item.checked)
        .map((element) => element.eventId);

      let eventIds = [];
      eventIds.push(Object.values(otherAmount), Object.values(paymentAmount));
      eventIds = [...new Set(eventIds.flat())];

      if (sendCommentCallback) {
        sendCommentCallback(eventId, comment, eventIds, token).then(
          function () {
            setComment("");
          }
        );
      }
    }
  };

  const renderPayment = (payment, i, index) => {
    return (
      <Grid container alignItems="center" key={i}>
        <Grid item xs={5} sm={6} md={3} lg={2} className={classes.flexStart}>
          {acceptPayments ? (
            <FormControlLabel
              control={
                <GreenCheckbox
                  color="primary"
                  checked={payment.checked}
                  onChange={() => handleChangePayment(index, i)}
                />
              }
              label={payment.paymentType.name}
              labelPlacement="end"
            />
          ) : (
            payment.paymentType.name
          )}
        </Grid>
        <Grid item xs={7} sm={3} md={2}>
          <NumericFormat
            thousandSeparator
            fixedDecimalScale
            decimalScale={2}
            allowNegative={false}
            prefix="$"
            value={payment.paymentAmount < 0 ? 0 : payment.paymentAmount}
            disabled={true}
            customInput={PaymentEntryField}
          />
        </Grid>
        <Grid item xs={5} sm={3} md={2} className={classes.flex}>
          <Typography variant="subtitle1" className={classes.smallFont}>
            (due on {formatSmallDate(payment.paymentDate)})
          </Typography>
        </Grid>
      </Grid>
    );
  };

  const pay = (language) => {
    let payment = [];
    let paymentType = paymentTypeOption === "1" ? "achCheck" : "creditDebit";
    let applyPaymentFeesToAll =
      paymentArray.filter((el) => el.event.applyTPPpayFee).length > 0;
    let applyGratuityToAll =
      paymentArray.filter((el) => el.event.applyTPPpayGratuity).length > 0;

    if (
      (selectedPaymentTypeOption === "1" && !applyACHPayFee) ||
      !applyTPPPayFee
    ) {
      applyPaymentFeesToAll = false;
    }
    paymentArray.forEach((element) => {
      if (element.otherAmountChecked) {
        if (!applyGratuityToAll) {
          paymentGratuityOption = 0;
        }
        payment.push({
          eventId: element.event.id,
          amount: element.otherAmount,
          invoiceNumber: element.event.invoiceNumber,
          scheduledPaymentId: -1,
          tppPayFeePercentage: applyPaymentFeesToAll ? tppPayFeePercentage : 0,
          tppPayFeeAmount: applyPaymentFeesToAll
            ? parseFloat(
                (
                  ((element.otherAmount +
                    parseFloat(
                      (
                        (element.otherAmount * paymentGratuityOption) /
                        100
                      ).toFixed(2)
                    )) *
                    tppPayFeePercentage) /
                  100
                ).toFixed(2)
              )
            : 0,
          typeOfFee: "PCT",
          tppPayGratuityPercentage: applyGratuityToAll
            ? paymentGratuityOption
            : 0,
          tppPayGratuityAmount: applyGratuityToAll
            ? parseFloat(
                ((element.otherAmount * paymentGratuityOption) / 100).toFixed(2)
              )
            : 0,
          typeOfGratuity: "PCT",
          paymentType: paymentType,
        });
      }
      element.scheduledPayments
        .filter((element) => element.checked)
        .forEach((el) => {
          el.invoiceInfo.paymentType = paymentType;
          if (applyGratuityToAll) {
            el.invoiceInfo.tppPayGratuityAmount = parseFloat(
              ((el.invoiceInfo.amount * paymentGratuityOption) / 100).toFixed(2)
            );
            el.invoiceInfo.tppPayGratuityPercentage = paymentGratuityOption;
            el.invoiceInfo.typeOfGratuity = "PCT";
          }
          if (applyPaymentFeesToAll) {
            el.invoiceInfo.tppPayFeeAmount = parseFloat(
              (
                ((el.invoiceInfo.amount + el.invoiceInfo.tppPayGratuityAmount) *
                  tppPayFeePercentage) /
                100
              ).toFixed(2)
            );
            el.invoiceInfo.tppPayFeePercentage = tppPayFeePercentage;
            el.invoiceInfo.typeOfFee = "PCT";
          } else {
            el.invoiceInfo.tppPayFeeAmount = 0;
            el.invoiceInfo.tppPayFeePercentage = 0;
            el.invoiceInfo.typeOfFee = "PCT";
          }
          payment.push(el.invoiceInfo);
        });
    });
    let numPayments = payment.length;
    setCustomSelected(0);

    if (numPayments && tppPayGratuityAmount && selectedGratuityPercent === 0) {
      payment.forEach((element) => {
        element.tppPayGratuityAmount = parseFloat(
          (
            (tppPayGratuityAmount * element.amount) /
            selectedinvoiceAmount
          ).toFixed(2)
        );
        element.tppPayGratuityPercentage = -1;
        element.tppPayFeeAmount = applyPaymentFeesToAll
          ? parseFloat(
              (
                ((element.amount + element.tppPayGratuityAmount) *
                  tppPayFeePercentage) /
                100
              ).toFixed(2)
            )
          : 0;
        element.typeOfGratuity = "FLT";
      });
    }

    if (payment.length > 0) {
      if (processPaymentCallback) {
        processPaymentCallback(
          payment,
          selectedGratuity.current,
          language
        ).then(
          (result) => {
            sendComment();
            setComment("");
            customGratuityAmount = 0;
          },
          (e) => {
            enqueueSnackbar("Failed to launch payment form.", {
              variant: "error",
            });
          }
        );
      }
    } else {
      enqueueSnackbar("Please enter an amount to pay to proceed", {
        variant: "error",
      });
    }
  };

  const handlePaymentTypeOptionChange = (value) => {
    setPaymentTypeOption(value);
    selectedPaymentTypeOption = value;
    calculateTotal();
  };

  const handleGratuityOptionChange = (value) => {
    setPaymentGratuityOption(parseFloat(value));
    selectedGratuityPercent = parseFloat(value);
    if (selectedGratuityPercent === defaultGratuity1) {
      selectedGratuity.current = 1;
    } else if (selectedGratuityPercent === defaultGratuity2) {
      selectedGratuity.current = 2;
    } else if (selectedGratuityPercent === defaultGratuity3) {
      selectedGratuity.current = 3;
    } else {
      selectedGratuity.current = 0;
    }
    if (selectedGratuityPercent === 0) {
      customGratuityAmount = 0;
    }
    setCustomSelected(customGratuityAmount);
    calculateTotal();
  };

  const renderCanPay = () => {
    const selectedPaymentCount = paymentArray
      .flatMap((el) =>
        el?.otherAmountChecked
          ? 1
          : el?.scheduledPayments.filter((sp) => sp.checked)?.length
      )
      .filter(Boolean)?.length;

    let displayFee =
      paymentArray.filter((el) => el.event.applyTPPpayFee).length > 0;
    let displayGratuity =
      paymentArray.filter((el) => el.event.applyTPPpayGratuity).length > 0;

    const showFee =
      (applyACHPayFee ||
        (Number(paymentTypeOption) === 0 && !applyACHPayFee) ||
        !showACH) &&
      applyTPPPayFee &&
      displayFee &&
      selectedinvoiceAmount > 0;

    const showPaymentMethod = showACH;

    const showPaymentGratuity = applyTPPPayGratuity && displayGratuity;
    const gratuityOptions = [
      { value: defaultGratuity1 },
      { value: defaultGratuity2 },
      { value: defaultGratuity3 },
      { value: 0, label: "Custom" },
    ];

    const showSubTotal = (applyTPPPayFee && displayFee) || showPaymentGratuity;

    const gratLabel = `Add ${
      tppPayGratuityLabel.includes("Additional ") ? "an" : ""
    } ${tppPayGratuityLabel}: `;
    return (
      <Grid container direction="row" justifyContent="center" mb={1}>
        <Grid item xs={12} md={6} container direction="column">
          {selectedPaymentCount > 0 && (
            <>
              <Typography variant="subtitle1"> Pay Selected Invoice</Typography>
              {showSubTotal && (
                <Grid item container direction="row">
                  <Typography
                    className={classes.paymentInfoLeft}
                    variant="subtitle1"
                  >
                    Subtotal:
                  </Typography>
                  <Typography className={classes.bold} variant="subtitle1">
                    {numberFormat(selectedinvoiceAmount)}
                  </Typography>
                </Grid>
              )}
              {showPaymentGratuity && (
                <Grid item container direction="row">
                  <Typography
                    variant="subtitle1"
                    className={classes.paymentInfoLeft}
                  >
                    {gratLabel}
                  </Typography>
                  <Stack gap={1} mx={1}>
                    <PaymentGratuity
                      options={gratuityOptions}
                      value={paymentGratuityOption}
                      onOptionChange={handleGratuityOptionChange}
                      paymentGratuityOption={paymentGratuityOption}
                      tppPayGratuityAmount={tppPayGratuityAmount}
                      onCustomGratuityChange={handleGratuityAmount}
                    ></PaymentGratuity>
                  </Stack>
                </Grid>
              )}
              {showPaymentMethod && (
                <Grid item container direction="row">
                  <Typography
                    variant="subtitle1"
                    sx={{
                      color: "red",
                      width: "300px",
                      textAlign: "right",
                      fontWeight: "bold",
                      paddingRight: 1,
                    }}
                  >
                    {" "}
                    Please Select Method of Payment:{" "}
                  </Typography>
                  <PaymentMethod
                    value={paymentTypeOption}
                    onChange={handlePaymentTypeOptionChange}
                  ></PaymentMethod>
                </Grid>
              )}

              {showFee && (
                <Grid item container direction="row">
                  <Typography
                    className={classes.paymentInfoLeft}
                    variant="subtitle1"
                  >
                    {tppPayFeePercentage}% {tppPayFeeLabel}:
                  </Typography>
                  <Typography className={classes.bold} variant="subtitle1">
                    {numberFormat(tppPayFeeAmount)}
                  </Typography>
                </Grid>
              )}
              <Grid item container direction="row">
                <Typography
                  className={classes.paymentInfoLeft}
                  variant="subtitle1"
                >
                  Total:
                </Typography>
                <Typography className={classes.bold} variant="subtitle1">
                  {numberFormat(selectedinvoiceTotalAmount)}
                </Typography>
              </Grid>
            </>
          )}
        </Grid>

        <Grid item xs={12} md={6}>
          <TextField
            id="filled-multiline-static"
            label={comment && comment.length ? "" : "Leave a comment..."}
            multiline
            rows={6}
            InputProps={{
              classes: { underline: classes.colorUnderline },
              style: { padding: 8 },
            }}
            onChange={(e) => setComment(e.target.value)}
            value={comment}
            fullWidth
            margin="normal"
            variant="filled"
          />
        </Grid>
        <Grid item xs={12}>
          <Typography variant="subtitle1">
            Date: {formatDate(new Date())}
          </Typography>
        </Grid>
        <Grid item xs={12} className={classes.center}>
          <Tooltip
            title={
              selectedinvoiceTotalAmount === 0
                ? "Please enter an amount to pay to proceed"
                : "Pay Selected Invoices"
            }
          >
            <WideColorButton
              variant="outlined"
              size="small"
              onClick={(e) => {
                if (!isCanadian) {
                  return pay("en-US");
                }
                setPayNowMenuAchnor(e?.currentTarget);
              }}
              disabled={
                selectedPaymentCount === 0 || selectedinvoiceTotalAmount === 0
              }
            >
              Pay Now
            </WideColorButton>
          </Tooltip>
          <Menu
            elevation={3}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "center",
            }}
            transformOrigin={{
              vertical: "top",
              horizontal: "center",
            }}
            open={Boolean(payNowMenuAnchor)}
            onClose={() => setPayNowMenuAchnor(null)}
            anchorEl={payNowMenuAnchor}
            sx={{
              mt: 1,
              "& .MuiPaper-root": {
                borderRadius: 2,
              },
            }}
          >
            <MenuItem
              onClick={() => {
                pay("en-US");
              }}
            >
              <ListItemIcon>
                <Public></Public>
              </ListItemIcon>
              English
            </MenuItem>
            <Divider></Divider>
            <MenuItem
              onClick={() => {
                pay("fr-CA");
              }}
            >
              <ListItemIcon>
                <TripOrigin></TripOrigin>
              </ListItemIcon>
              Français’
            </MenuItem>
          </Menu>
        </Grid>
      </Grid>
    );
  };

  return (
    <Grid container direction="row" justifyContent="center">
      {paymentArray.map((element, index) => {
        return (
          <Grid item xs={12} className={classes.border} key={index}>
            <Grid container>
              <Grid item xs={12}>
                <Grid container>
                  <Grid item xs={6} md={12}>
                    <PopoverEventDetails event={element.event} />
                  </Grid>
                  <Grid item xs={6}>
                    <Typography variant="subtitle1">
                      Event Total:{" "}
                      {numberFormat(element.event.financials.total)}
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>

              <Grid item xs={12}>
                {element.scheduledPayments
                  .sort(
                    (a, b) => new Date(a.paymentDate) - new Date(b.paymentDate)
                  )
                  .map((payment, i) => {
                    if (["SP", "SD"].indexOf(payment.paymentType.id) > -1) {
                      if (payment.paymentAmount < 0 || !showScheduledPayments) {
                        return <></>;
                      }
                    }
                    return renderPayment(payment, i, index);
                  })}
                {acceptPayments && allowPartialPayments ? (
                  <Grid container alignItems="center">
                    <Grid
                      item
                      xs={5}
                      sm={6}
                      md={3}
                      lg={2}
                      className={classes.flexStart}
                    >
                      <FormControlLabel
                        value="end"
                        control={
                          <GreenCheckbox
                            checked={element.otherAmountChecked}
                            onChange={() => otherAmountCheck(element)}
                          />
                        }
                        label="Other amount"
                        labelPlacement="end"
                      />
                    </Grid>
                    <Grid
                      item
                      xs={7}
                      sm={3}
                      md={2}
                      className={classes.flexStart}
                    >
                      <NumericFormat
                        thousandSeparator
                        fixedDecimalScale
                        decimalScale={2}
                        prefix="$"
                        allowNegative={false}
                        onValueChange={(values) =>
                          handleAmount(index, values.floatValue)
                        }
                        customInput={PaymentEntryField}
                      />
                    </Grid>
                  </Grid>
                ) : null}
              </Grid>
              {element.payments.length > 0 ? (
                <React.Fragment>
                  <Grid
                    item
                    xs={12}
                    onClick={() => handleChange(index)}
                    className={classes.flexCenter}
                  >
                    <Typography variant="subtitle1" className={classes.bold}>
                      Show More
                    </Typography>
                    <KeyboardArrowDown
                      className={
                        element.showMore ? classes.iconActive : classes.icon
                      }
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <Fade in={element.showMore}>
                      {element.showMore ? (
                        <Grid item xs={12} className={classes.margin}>
                          <Typography
                            variant="subtitle1"
                            className={classes.bold}
                          >
                            Previous Payments
                          </Typography>
                          {element.payments.map((pastPayments, index) => {
                            return (
                              <Grid container key={index}>
                                <Grid item xs={4} md={1}>
                                  {formatSmallDate(pastPayments.paymentDate)}
                                </Grid>
                                <Grid item xs={4} md={1}>
                                  {pastPayments.paymentType.name}
                                </Grid>
                                <Grid item xs={4} md={1}>
                                  {pastPayments.paymentAmount > 0 ? (
                                    numberFormat(pastPayments.paymentAmount)
                                  ) : (
                                    <span className={classes.red}>
                                      {" "}
                                      (
                                      {numberFormat(pastPayments.paymentAmount)}
                                      ){" "}
                                    </span>
                                  )}
                                </Grid>
                              </Grid>
                            );
                          })}
                        </Grid>
                      ) : (
                        <Grid container></Grid>
                      )}
                    </Fade>
                  </Grid>
                </React.Fragment>
              ) : null}
            </Grid>
          </Grid>
        );
      })}
      {acceptPayments ? renderCanPay() : null}
    </Grid>
  );
};

PaymentsSchedule.propTypes = {
  classes: PropTypes.object.isRequired,
};
export default withStyles(styles)(PaymentsSchedule);
